import { dateFormatter } from '../../utils/formaters';
const EntranceExitTableItemDtoToEntranceExitTableItem = (entranceExitTabledto) => entranceExitTabledto?.map(dto => ({
    id: dto.atendimentoId,
    plate: dto.placa,
    model: dto.modelo || '-',
    entranceData: dto.dataEntrada ? dateFormatter(dto.dataEntrada) : '-',
    exitDate: dto.dataSaida ? dateFormatter(dto.dataSaida) : '-',
    backupPlate: dto.placaReserva || '-',
}));
export const EntranceExitTableDtoToEntranceExitTable = (entranceExitTabledto) => ({
    itens: EntranceExitTableItemDtoToEntranceExitTableItem(entranceExitTabledto.listagem),
    pageCount: entranceExitTabledto.totalPaginas,
    rows: entranceExitTabledto.totalRegistros,
});
export const EntranceExitChartDtoToEntranceExitChart = (entranceExitChartdto) => entranceExitChartdto?.map(dto => ({
    id: dto.id,
    entrance: dto.quantidadeEntradaVeiculosManutencao,
    exit: dto.quantidadeSaidaVeiculosManutencao,
}));
export const EntranceExitChartDtoToEntranceExitTotalChart = (entranceExitChartdto) => entranceExitChartdto?.map(dto => ({
    id: dto.id,
    total: dto.quantidadeEntradaVeiculosManutencao +
        dto.quantidadeSaidaVeiculosManutencao,
}));
